import { collection, getAggregateFromServer, query, sum, where } from "firebase/firestore";
import { useEffect, useState } from "react";
import { collectionPath } from "../context/EnvContext";
import { useFirestore } from "../firebase/FirestoreContext";
import { getAuth } from "firebase/auth";
import noop from "../functions/noop";

export default function useWallet() {
  const auth = getAuth();
  const { currentUser: user } = auth;
  const firestore = useFirestore();
  const [balance, setBalance] = useState(0);

  useEffect(() => {
    if (!user?.uid) return noop;

    const fetchBalance = async () => {
      const walletCollection = query(
        collection(firestore, `${collectionPath}Wallets/UserWallets/DataBase`),
        where('user_uid', '==', user.uid),
      );
      const snapshot = await getAggregateFromServer(walletCollection, { balance: sum('wallet_value') })

      const data = snapshot.data();
      setBalance(data.balance);
    }
    fetchBalance();
  }, [setBalance, firestore, user?.uid]);

  return { balance };
}
